import { render, staticRenderFns } from "./ActiveCurrenciesModal.vue?vue&type=template&id=4c7f39e6&scoped=true&"
import script from "./ActiveCurrenciesModal.vue?vue&type=script&lang=js&"
export * from "./ActiveCurrenciesModal.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCurrenciesModal.vue?vue&type=style&index=0&id=4c7f39e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7f39e6",
  null
  
)

export default component.exports